import { baseUrl, getBaseApiUrl } from "./../env";
import BaseAPI from "./baseAPI";

let params = new URL(document.location).searchParams;
let type = params.get("type");
let section_id = params.get("section_id");

type = "assessments";

const getReviewTestUrl = ({quiz_id}) => `${getBaseApiUrl()}/${type}/${quiz_id}/?section_id=${section_id}`;
const getQuizUrl = (quiz_id) => `${getBaseApiUrl()}/assessments/${quiz_id}/?id=undefined`;
const getTestUrl = () => `${getBaseApiUrl()}/elab/language-tests/`;
const getResultUrl = (test_id) => `${getBaseApiUrl()}/elab/test-performance/${test_id}`;
const getTestSubmissionUrl = (quiz_id) => `${baseUrl}/student_test_status/${quiz_id}`;

class API extends BaseAPI {
  constructor(props) {
    super(props);
    this.props = props;
  }

  getStartTestUrl = (testId) => {
    return this.postSecure({ url: `${getBaseApiUrl()}/elab/start-test/${testId}` });
  };
  getAvailableTests = () => {
    return this.fetchSecure({ url: getTestUrl() });
  };
  
  get_result = ({ id }) => {
    return this.fetchSecure({ url: getResultUrl(id) });
  };

  get = ({ id }) => {
    if (section_id)
    {
      return this.fetchSecure({ url: getReviewTestUrl({quiz_id: id}) });
    } else {
        return this.fetchSecure({ url: getQuizUrl(id) });
    }
  };

  get_submission_status = ({ id }) => {
    return this.fetchSecure({ url: getTestSubmissionUrl(id) });
  };

  post = ({ id, data }) => {
    return this.postSecure({ url: getQuizUrl(id), data });
  };
}

const apiInstance = new API();
export default apiInstance;
